import { containsFilter } from '@/modules/service-desk/shared/application-api';
import { MetlifeApplicationType, MetlifeStatus } from '../types/metlife.types';

export interface MetlifeRequestFilters {
  keyword: string;
  typeOfApplication: MetlifeApplicationType | '';
  departmentId: string;
  status: MetlifeStatus | '';
}

export const EMPTY_METLIFE_FILTERS: MetlifeRequestFilters = {
  keyword: '',
  typeOfApplication: '',
  departmentId: '',
  status: '',
};

/**
 * Legacy `BuildMetLifeQuery`: the keyword matches either the policy applicant's name or the
 * employee's name; type, status and department match exactly. The department is the applicant's own
 * (`DepartmentId`, stamped when applying), the one the head-of-department data rule scopes on through
 * `DepartmentKey`, so a head of department sees every application the rule lets them read.
 * `departmentCondition` comes from `useDepartmentScope().getDepartmentIdCondition`.
 */
export const buildMetlifeFilter = (
  filters: MetlifeRequestFilters,
  departmentCondition: string | { $in: string[] } | undefined
) => ({
  ...(filters.status ? { Status: filters.status } : {}),
  ...(filters.typeOfApplication ? { TypeOfApplication: filters.typeOfApplication } : {}),
  ...(departmentCondition ? { DepartmentId: departmentCondition } : {}),
  ...(filters.keyword.trim()
    ? {
        $or: [
          { PolicyApplicantName: containsFilter(filters.keyword) },
          { Name: containsFilter(filters.keyword) },
        ],
      }
    : {}),
});
